/* assets/gproperty-family-fit-flow.js — GPROPERTY-FAMILY-FIT-07
 * GP-07 canonical Family Fit runtime.
 * Consumes verified GProperty draft + public readiness through GPROPERTY_DATA_GATE.
 * target_school and max_commute remain local-only and never enter the API payload.
 * No direct localStorage/fetch owner; no technical request/result identifiers in consumer UI.
 */
(function (window, document) {
  'use strict';

  var ROOT = '[data-gproperty-family-fit]';
  var VERSION = 'gproperty-family-fit-07';
  var FORBIDDEN_CONSUMER_TOKENS =
    /(?:serving_ready|public_redacted|request[_ ]?id|result[_ ]?id|data_source_not_ready|verified_family_data_unavailable|mock_data|\bDPO\b|\bALS\b|endpoint|contract|fail[- ]?closed)/i;

  function all(root, selector) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function value(form, name) {
    var field = form.elements.namedItem(name);
    return field
      ? String(field.value || '')
          .replace(/\s+/g, ' ')
          .trim()
      : '';
  }

  function setText(root, selector, next) {
    var node = root.querySelector(selector);
    if (node) node.textContent = next;
  }

  function locale(root) {
    return String(root.getAttribute('data-family-locale') || 'en').trim();
  }

  function copy(root) {
    var lang = locale(root);
    var en = {
      noAddress: 'No verified address is saved on this device.',
      noAddressDetail: 'Return to GProperty and verify an address before continuing.',
      routeMismatch:
        'This link does not match the verified address saved on this device. Choose the address again before continuing.',
      coordinateVerified: 'Verified location',
      coordinateMissing: 'Location details incomplete',
      intentRequired: 'Choose what you are considering first.',
      consentRequired: 'Confirm the preview data use before creating the preview.',
      localSaveFailed: 'This browser could not save the family preferences.',
      localSaved: 'Family preferences saved on this device.',
      checkingTitle: 'Checking available public information',
      checkingCopy:
        'Your address and family preferences are handled separately from public-data availability.',
      checkingBadge: 'Checking',
      readyTitle: 'Preview data is available',
      readyCopy: 'You can save your preferences or create a preview when you choose.',
      readyBadge: 'Available',
      blockedTitle: 'Preview data is not ready yet',
      blockedCopy: 'Your preferences can still be saved on this device.',
      blockedBadge: 'Save locally',
      readinessErrorTitle: 'Availability could not be checked',
      readinessErrorCopy: 'Your preferences can still be saved on this device.',
      previewLoading: 'Creating preview…',
      submitDraft: 'Save family preferences',
      submitPreview: 'Create Workplace Comparison',
      failClosed:
        'Your preferences are saved on this device. A preview will only be created when the required public information is available.',
      previewError: 'The preview could not be created. Your local preferences are still saved.',
      resultTitle: 'Workplace Comparison ready',
      resultCopy: 'Available public information has been organised for this address.',
      resultStatus: 'Ready',
    };

    if (lang === 'zh-Hans') {
      return {
        noAddress: '此设备尚未保存已核实地址。',
        noAddressDetail: '请先返回 GProperty 核实地址后再继续。',
        routeMismatch: '此链接与本设备保存的已核实地址不一致，请重新选择地址后继续。',
        coordinateVerified: '位置已核实',
        coordinateMissing: '位置资料不完整',
        intentRequired: '请先选择你现在考虑的情况。',
        consentRequired: '建立预览前，请先确认本次资料使用。',
        localSaveFailed: '此浏览器无法保存家庭偏好。',
        localSaved: '家庭偏好已保存在此设备。',
        checkingTitle: '正在检查可用公开资料',
        checkingCopy: '地址、家庭偏好和公开资料可用状态会分别处理。',
        checkingBadge: '检查中',
        readyTitle: '建立预览所需资料已可用',
        readyCopy: '請先保存偏好，也可以在确认后建立预览。',
        readyBadge: '可用',
        blockedTitle: '建立预览所需资料暂未准备好',
        blockedCopy: '你仍可把家庭偏好保存在此设备。',
        blockedBadge: '仅保存',
        readinessErrorTitle: '暂时无法检查资料状态',
        readinessErrorCopy: '你仍可把家庭偏好保存在此设备。',
        previewLoading: '正在建立预览…',
        submitDraft: '保存家庭偏好',
        submitPreview: '建立家庭生活预览',
        failClosed: '家庭偏好已保存在此设备；只有所需公开资料可用时才会建立预览。',
        previewError: '暂时无法建立预览，本地偏好仍然保留。',
        resultTitle: '家庭生活预览已准备好',
        resultCopy: '已为这个地址整理可用公开资料。',
        resultStatus: '已准备好',
      };
    }

    if (lang === 'zh-Hant') {
      return {
        noAddress: '此裝置尚未儲存已核實地址。',
        noAddressDetail: '請先返回 GProperty 核實地址後再繼續。',
        routeMismatch: '此連結與本裝置儲存的已核實地址不一致，請重新選擇地址後繼續。',
        coordinateVerified: '位置已核實',
        coordinateMissing: '位置資料不完整',
        intentRequired: '請先選擇你現在考慮的情況。',
        consentRequired: '建立預覽前，請先確認本次資料使用。',
        localSaveFailed: '此瀏覽器無法儲存家庭偏好。',
        localSaved: '家庭偏好已儲存在此裝置。',
        checkingTitle: '正在檢查可用公開資料',
        checkingCopy: '地址、家庭偏好和公開資料可用狀態會分開處理。',
        checkingBadge: '檢查中',
        readyTitle: '建立預覽所需資料已可用',
        readyCopy: '請先儲存偏好，也可以在確認後建立預覽。',
        readyBadge: '可用',
        blockedTitle: '建立預覽所需資料暫未準備好',
        blockedCopy: '你仍可把家庭偏好儲存在此裝置。',
        blockedBadge: '只儲存',
        readinessErrorTitle: '暫時無法檢查資料狀態',
        readinessErrorCopy: '你仍可把家庭偏好儲存在此裝置。',
        previewLoading: '正在建立預覽…',
        submitDraft: '儲存家庭偏好',
        submitPreview: '建立家庭生活預覽',
        failClosed: '家庭偏好已儲存在此裝置；只有所需公開資料可用時才會建立預覽。',
        previewError: '暫時無法建立預覽，本機偏好仍然保留。',
        resultTitle: '家庭生活預覽已準備好',
        resultCopy: '已為這個地址整理可用公開資料。',
        resultStatus: '已準備好',
      };
    }

    return en;
  }

  function safeConsumerText(gate, value, fallback) {
    var cleaned = gate.clean(value);
    if (!cleaned || FORBIDDEN_CONSUMER_TOKENS.test(cleaned)) return fallback;
    return cleaned.slice(0, 600);
  }

  function setState(root, name, message) {
    root.setAttribute('data-state', name);
    all(root, '[data-family-state]').forEach(function (node) {
      node.hidden = node.getAttribute('data-family-state') !== name;
    });
    if (name === 'error' && message) setText(root, '[data-family-error-copy]', message);
    if (name === 'blocked' && message) setText(root, '[data-family-blocked-copy]', message);
    var submit = root.querySelector('[data-family-submit]');
    if (submit) submit.disabled = name === 'loading';
  }

  function readinessUI(root, mode, title, text, badge) {
    var node = root.querySelector('[data-family-readiness]');
    if (node) node.setAttribute('data-mode', mode);
    setText(root, '[data-family-readiness-title]', title);
    setText(root, '[data-family-readiness-copy]', text);
    setText(root, '[data-family-readiness-badge]', badge);
  }

  function setSubmitLabel(submit, serving, strings) {
    if (!submit) return;
    submit.textContent = serving ? strings.submitPreview : strings.submitDraft;
  }

  /** @param {HTMLElement} root */
  function init(root) {
    if (!root || root.getAttribute('data-runtime-version') === VERSION) return;
    root.setAttribute('data-runtime-version', VERSION);

    var gate = window.GPROPERTY_DATA_GATE;
    var form = root.querySelector('[data-family-form]');
    var submit = root.querySelector('[data-family-submit]');
    var consent = root.querySelector('[data-family-consent]');
    var panel = root.querySelector('[data-family-result-panel]');
    if (!gate || !form || !submit || !consent) return;

    var strings = copy(root);
    var propertyKey = root.getAttribute('data-property-draft-key') || gate.canonicalDraftKey;
    var legacyPropertyKey =
      root.getAttribute('data-legacy-property-draft-key') || gate.legacyDraftKey;
    var flowKey = root.getAttribute('data-flow-draft-key');
    var stored = gate.readPropertyDraft(propertyKey, legacyPropertyKey);
    var property = stored && stored.draft;
    var requestedRecord = gate.opaque(
      new URLSearchParams(window.location.search || '').get('record_id')
    );
    var localRecord = gate.opaque(property && property.record_id);
    var routeMismatch = !!(requestedRecord && requestedRecord !== localRecord);
    var verified = !routeMismatch && gate.isVerifiedDraft(property);
    var serving = false;

    function focusPanel() {
      if (!panel) return;
      try {
        panel.focus({ preventScroll: true });
      } catch (_) {
        panel.focus();
      }
      panel.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start',
      });
    }

    function hydrateAddress() {
      var addressStep = root.querySelector('[data-family-step="address"]');
      if (routeMismatch) {
        setText(root, '[data-family-address-name]', strings.noAddress);
        setText(root, '[data-family-address-detail]', strings.routeMismatch);
        if (addressStep) addressStep.classList.add('is-blocked');
        return;
      }
      if (!verified) {
        setText(root, '[data-family-address-name]', strings.noAddress);
        setText(root, '[data-family-address-detail]', strings.noAddressDetail);
        if (addressStep) addressStep.classList.add('is-blocked');
        return;
      }
      var estate = property.estate_context;
      setText(root, '[data-family-address-name]', gate.locationLabel(estate));
      setText(
        root,
        '[data-family-address-detail]',
        [
          estate.address_zh || estate.address_en,
          estate.district_zh || estate.district_en,
          estate.coordinate_verified ? strings.coordinateVerified : strings.coordinateMissing,
        ]
          .filter(Boolean)
          .join(' · ')
      );
      if (addressStep) addressStep.classList.add('is-complete');
    }

    function hydratePreferences() {
      var draft = gate.read(flowKey);
      if (!draft || typeof draft !== 'object') return;
      [
        'intent',
        'family_priority',
        'school_net',
        'target_school',
        'commute_destination',
        'max_commute',
        'child_age',
        'budget',
        'notes',
      ].forEach(function (name) {
        if (form.elements.namedItem(name) && draft[name] != null)
          form.elements.namedItem(name).value = draft[name];
      });
    }

    function collect() {
      return {
        schema_version: 'gproperty.v2',
        source: 'gproperty_family_fit',
        type: 'preview',
        result_surface: 'workspace',
        record_id: gate.opaque(property && property.record_id),
        estate_context: verified ? property.estate_context : null,
        estate_name: verified ? gate.locationLabel(property.estate_context) : '',
        intent: value(form, 'intent'),
        family_priority: value(form, 'family_priority') || 'balanced',
        school_net: value(form, 'school_net'),
        target_school: value(form, 'target_school'),
        commute_destination: value(form, 'commute_destination'),
        max_commute: value(form, 'max_commute'),
        child_age: value(form, 'child_age'),
        budget: value(form, 'budget'),
        notes: value(form, 'notes'),
        consent: !!(
          form.elements.namedItem('consent') && form.elements.namedItem('consent').checked
        ),
        mock_data_used: false,
      };
    }

    function apiPayload(payload) {
      var outgoing = Object.assign({}, payload);
      delete outgoing.target_school;
      delete outgoing.max_commute;
      return outgoing;
    }

    function validate(payload) {
      if (routeMismatch) return strings.routeMismatch;
      if (!verified) return strings.noAddressDetail;
      if (!payload.intent) return strings.intentRequired;
      if (serving && !payload.consent) return strings.consentRequired;
      return '';
    }

    function saveLocal(payload) {
      return gate.write(
        flowKey,
        Object.assign({}, payload, {
          consent: false,
          backend_submission: false,
          readiness_serving_ready: serving,
          local_only_fields: ['target_school', 'max_commute'],
          updated_at: new Date().toISOString(),
        })
      );
    }

    function saveResultReference(resultId) {
      var safeResultId = gate.opaque(resultId);
      if (!safeResultId || !property || !gate.isVerifiedDraft(property)) return false;
      var references = Object.assign({}, property.fit_references || {});
      references.family_fit = {
        result_id: safeResultId,
        status: 'ready',
        updated_at: new Date().toISOString(),
      };
      var next = Object.assign({}, property, {
        fit_references: references,
        updated_at: new Date().toISOString(),
      });
      var saved = gate.writePropertyDraft(propertyKey, next);
      if (saved) property = gate.readPropertyDraft(propertyKey, legacyPropertyKey).draft;
      return saved;
    }

    function success(body) {
      var data = body && body.data && typeof body.data === 'object' ? body.data : body;
      var resultId = gate.opaque((data && data.result_id) || (body && body.result_id));
      if (!resultId) throw new Error('family_fit_contract_invalid');
      saveResultReference(resultId);
      setText(root, '[data-family-result-title]', strings.resultTitle);
      setText(
        root,
        '[data-family-result-copy]',
        safeConsumerText(gate, (data && data.summary) || (body && body.summary), strings.resultCopy)
      );
      setText(root, '[data-family-result-status]', strings.resultStatus);
      setState(root, 'result');
      var resultStep = root.querySelector('[data-family-step="result"]');
      if (resultStep) resultStep.classList.add('is-complete');
      focusPanel();
    }

    function post(payload) {
      var idempotencyKey =
        window.crypto && typeof window.crypto.randomUUID === 'function'
          ? window.crypto.randomUUID()
          : 'family-fit-' + Date.now();
      var outgoing = apiPayload(payload);
      setState(root, 'loading');
      submit.textContent = strings.previewLoading;
      focusPanel();

      gate
        .request(
          root.getAttribute('data-api-endpoint'),
          {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Idempotency-Key': idempotencyKey,
            },
            body: JSON.stringify(Object.assign({}, outgoing, { idempotency_key: idempotencyKey })),
          },
          20000
        )
        .then(function (response) {
          var body = response.body || {};
          if (gate.isFailClosed(response.http_status, body)) {
            serving = false;
            consent.hidden = true;
            setSubmitLabel(submit, false, strings);
            setState(root, 'blocked', strings.failClosed);
            focusPanel();
            return;
          }
          if (!response.response_ok || body.ok === false || body.success === false) {
            throw new Error('family_fit_failed');
          }
          success(body);
        })
        .catch(function () {
          setState(root, 'error', strings.previewError);
          focusPanel();
        })
        .finally(function () {
          submit.disabled = false;
          setSubmitLabel(submit, serving, strings);
        });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var payload = collect();
      var problem = validate(payload);
      setText(root, '[data-family-form-status]', problem);
      if (problem) {
        setState(root, verified && !routeMismatch ? 'idle' : 'blocked', problem);
        focusPanel();
        return;
      }
      if (!saveLocal(payload)) {
        setText(root, '[data-family-form-status]', strings.localSaveFailed);
        return;
      }
      var conditionsStep = root.querySelector('[data-family-step="conditions"]');
      if (conditionsStep) conditionsStep.classList.add('is-complete');
      if (!serving) {
        setState(root, 'blocked', strings.failClosed);
        setText(root, '[data-family-form-status]', strings.localSaved);
        focusPanel();
        return;
      }
      post(payload);
    });

    hydrateAddress();
    hydratePreferences();
    readinessUI(
      root,
      'checking',
      strings.checkingTitle,
      strings.checkingCopy,
      strings.checkingBadge
    );

    gate
      .publicReadiness(root.getAttribute('data-readiness-endpoint'))
      .then(function (response) {
        var body = response.body || {};
        if (!response.response_ok) throw new Error('readiness_failed');
        if (gate.isServingReady(body)) {
          serving = true;
          readinessUI(root, 'ready', strings.readyTitle, strings.readyCopy, strings.readyBadge);
          consent.hidden = false;
          setSubmitLabel(submit, true, strings);
          setState(
            root,
            verified && !routeMismatch ? 'idle' : 'blocked',
            verified ? '' : routeMismatch ? strings.routeMismatch : strings.noAddressDetail
          );
          var readinessStep = root.querySelector('[data-family-step="readiness"]');
          if (readinessStep) readinessStep.classList.add('is-complete');
        } else if (gate.isPublicRedacted(body)) {
          serving = false;
          readinessUI(
            root,
            'blocked',
            strings.blockedTitle,
            strings.blockedCopy,
            strings.blockedBadge
          );
          consent.hidden = true;
          setSubmitLabel(submit, false, strings);
          setState(
            root,
            verified && !routeMismatch ? 'idle' : 'blocked',
            verified ? '' : routeMismatch ? strings.routeMismatch : strings.noAddressDetail
          );
        } else {
          serving = false;
          readinessUI(
            root,
            'error',
            strings.readinessErrorTitle,
            strings.readinessErrorCopy,
            strings.blockedBadge
          );
          consent.hidden = true;
          setSubmitLabel(submit, false, strings);
          setState(root, 'blocked', strings.failClosed);
        }
      })
      .catch(function () {
        serving = false;
        readinessUI(
          root,
          'error',
          strings.readinessErrorTitle,
          strings.readinessErrorCopy,
          strings.blockedBadge
        );
        consent.hidden = true;
        setSubmitLabel(submit, false, strings);
        setState(root, 'blocked', strings.failClosed);
      });
  }

  function boot(scope) {
    var target = scope || document;
    if (target.matches && target.matches(ROOT)) init(target);
    all(target, ROOT).forEach(init);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        boot(document);
      },
      { once: true }
    );
  } else {
    boot(document);
  }
})(window, document);
